import React from 'react';
import About from './subcomponent/About';
import Vision from './subcomponent/Vision';
import Mission from './subcomponent/Mission';
import Objectives from './subcomponent/Objectives';
import Banner from './subcomponent/Banner';
import image3 from "../../asset/Image3.jpeg"

const Home = () => {
  return (
    <>
        <Banner />
        <div className="container py-4">
            <About />
            <Vision />
            <Mission />
            <Objectives />
            <img src={image3} className='img-home-page'/>
        </div>
    </>
  );
};

export default Home;
